import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import {
    AccountNavLinkWrapper,
    AccountNavText,
} from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/AccountNavigation.style';
import { UniverseComponent } from 'src/domains/common/universes';
import { useCommon } from 'src/domains/common/Common';
import { LocalStorageState } from 'src/domains/layouts/state/localStorage/LocalStorageState';
import { Amount } from 'src_common/common/amount/Amount';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { AccountNavVariantType } from 'src/domains/layouts/config/features/types';
import { UsersState } from 'src/domains/players/state/UsersState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const AccountLinkNav = observer('AccountLinkNav', () => {
    const common = useCommon();
    const localStorageState = LocalStorageState.get(common);
    const usersState = UsersState.get(common);
    const configState = ConfigComponents.get(common).config;
    const basicDataModel = BasicDataModel.get(common);

    const showBalanceInHeader = localStorageState.balanceInHeader.getValue();
    const playableBalance = usersState.walletData.valueReady?.playableBalance;
    const { accountNavVariant } = configState.componentVariants;

    return (
        <AccountNavLinkWrapper
            dataTest='account-navigation-account'
            to={{ account: 'summary' }}
            routeNameForGtm='account-summary'
            variant={accountNavVariant}
        >
            <UniverseComponent>
                {(universeModule): React.ReactElement => <universeModule.accountIcon />}
            </UniverseComponent>
            {accountNavVariant === AccountNavVariantType.SECONDARY && playableBalance !== undefined ? (
                showBalanceInHeader === true ? (
                    <div>{basicDataModel.money(new Amount(playableBalance))}</div>
                ) : (
                    <I18n
                        langKey='account.navigation.balance.hidden'
                        defaultText='Hidden'
                    />
                )
            ) : (
                <AccountNavText variant={accountNavVariant}>
                    <I18n
                        langKey='account.navigation.account'
                        defaultText='Account'
                    />
                </AccountNavText>
            )}
        </AccountNavLinkWrapper>
    );
});
